module.exports = __webpack_public_path__ + "img/jt.9de83ca1.png";